import { createContext, type PropsWithChildren, useContext, useEffect, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useInboxLayerContext } from 'pages/settings/pages/inboxes/context/inboxLayerContext'
import { BuyNumberStepsStore } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/BuyNumber/store/buyNumberStore'

const BuyNumberStepsContext = createContext<BuyNumberStepsStore | null>(null)

export const useBuyNumberStepsContext = () => {
  const context = useContext(BuyNumberStepsContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with BuyNumberStepsContext')

  return context
}

export const BuyNumberStepsProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const inboxLayerStore = useInboxLayerContext()
  const store = useMemo(
    () => new BuyNumberStepsStore(inboxLayerStore, entities),
    [inboxLayerStore, entities]
  )

  useEffect(() => {
    store.init()

    return () => {
      store.dispose()
    }
  }, [store])

  return <BuyNumberStepsContext.Provider value={store}>{children}</BuyNumberStepsContext.Provider>
}
